"use client";

import { useQuery } from "@tanstack/react-query";
import type { TutorialMissionStatusDto } from "@/lib/tutorial/progress";

export const TUTORIAL_MISSIONS_QUERY_KEY = ["tutorial-missions"] as const;

/**
 * 自分のチュートリアルミッションのクリア状況。
 * 未ログイン (401) は null を返す (ログイン前でも開ける使い方ガイドに Host を置いているため、エラーにしない)。
 */
async function fetchTutorialMissionStatus(): Promise<TutorialMissionStatusDto[] | null> {
  const res = await fetch("/api/tutorial-missions");
  if (res.status === 401) return null;
  if (!res.ok) throw new Error(`tutorial-missions: ${res.status}`);
  const body = (await res.json()) as { missions?: TutorialMissionStatusDto[] };
  return Array.isArray(body.missions) ? body.missions : [];
}

export function useTutorialMissionStatus() {
  return useQuery({
    queryKey: TUTORIAL_MISSIONS_QUERY_KEY,
    queryFn: fetchTutorialMissionStatus,
    staleTime: 60 * 1000,
    retry: 1,
  });
}

export interface ClearTutorialMissionResponse {
  key: string;
  cleared: boolean;
  rewardPoint: number;
  clearedAt: string;
  newBalance: number | null;
}

/** クリアを頼む。409 (登録のミッションの条件を満たしていない) などは null */
export async function postTutorialMissionClear(
  key: string,
): Promise<ClearTutorialMissionResponse | null> {
  const res = await fetch(`/api/tutorial-missions/${encodeURIComponent(key)}/clear`, {
    method: "POST",
  });
  if (!res.ok) return null;
  return (await res.json()) as ClearTutorialMissionResponse;
}
